window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  var arrayIncludes = function(e, t) {
    for (var n = 0; n < e.length; n++)
      if (e[n] == t) return !0;
    return !1;
  };

  var uniq = function(e) {
    for (var t = [], n = 0; n < e.length; n++) arrayIncludes(t, e[n]) || t.push(e[n]);
    return t;
  }

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    var _this = this;

    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));

    // Trigger change on load
    $(this.singleOptionSelector, this.$container).first().change();

    var productHasColor = this.product.options.reduce(function(acc, color) {
      if( color.toLowerCase() == "color" ) {
        acc = true;
      }

      return acc;
    }, false);

    // Init linked options
    if( productHasColor ) {
      $(document).on("swatchload", function() {
        _this._initLinkedOptions();
      });
    } else {
      _this._initLinkedOptions();
    }
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      // console.log(variant);

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }

      $('#Quantity').prop('max', inv_qty[variant.id]);
      
//       console.log(variant.inventory_quantity);
      if( variant.inventory_quantity > 0 ){
        var innerOptionHtml = '';
        if( variant.inventory_quantity > 10 ){
          for (let i = 1; i <= 10; i++) {
            innerOptionHtml += `<option value="${i}">${i}</option>`;
          }
        }else{
          for (let i = 1; i <= variant.inventory_quantity; i++) {
            innerOptionHtml += `<option value="${i}">${i}</option>`;
          }
        }
$('#Quantity, .qty-label').show();
        $('#Quantity').html(innerOptionHtml);
      }else{
        $('#Quantity, .qty-label').hide();

      }
      
// 	console.log(innerOptionHtml);
     
      
      // hide old cart errors
      $('#cart-error-message').removeClass("show").addClass("hide");

      // Back in stock app
      if (variant && variant.available) {
        $('#BIS_trigger').hide(); // hide the button
      } else {
        $('#BIS_trigger').show().attr('data-variant-id', variant.id); // show the button and set the default variant
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var params = Object.assign(this._getUrlParams(), {
        variant: variant.id
      });

      var url = window.location.href.replace(window.location.search, "") + "?" + $.param(params);

      window.history.replaceState({}, null, url);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    },

    _getUrlParams: function(str) {
      var str=str||document.location.search;return""==str?{}:str.replace(/(^\?)/,"").split("&").map(function(n) {
        return n=n.split("="),this[decodeURIComponent(n[0])]=decodeURIComponent(n[1]), this
      }.bind({}))[0]
    },

    _initLinkedOptions: function() {
      var this_ = this;

      var product = this.product;

      var selector = $("[data-single-option-selector]:eq(0)");

      selector.trigger("change");

      if( product.options.length == 1 ) {
        product.variants.forEach(function(variant) {
          if( !variant.available ) {
            $("[data-single-option-selector] option")
              .filter(function() {
                return $(this).text().trim() == variant.title;
              })
              .append(" - Sold out");
          }
        });

        $("[data-single-option-selector]").trigger("change");

        setTimeout(function() {
          $("[data-product-select] option").each(function() {
            var title = $(this).text().trim();

            var swatch = $(".swatchColor").filter(function() {
              return $(this).find(".innerText").text().trim() == title;
            });

            if( !$(this)[0].disabled ) {
              return;
            }

            swatch.addClass("is-disabled");
          });
        }, 100);
      } else {
        if( product.available ) {
          setTimeout(function() {
            this_._linkOptionSelectors(product);

            var optionsMap = this_._getNewOptionsMap();

            setTimeout(function() {
              $(".swatchColor").each(function() {
                var key = $(this).find(".innerText").text().trim();
                var match = optionsMap[key] ? optionsMap[key].available : null;

                if( !match ) {
                  $(this).addClass("is-disabled");
                }
              });
            }, 100);
          }, 100);
        }
      }
    },

    _linkOptionSelectors: function() {
      var _this = this;
      var product = this.product;

      // Update options right away.
      this._updateOptionsInSelector(0);

      if( product.options.length > 1 ) {
        this._updateOptionsInSelector(1)
      };

      if( product.options.length > 2 ) {
        this._updateOptionsInSelector(2)
      };

      // When there is an update in the first dropdown.
      $("[data-single-option-selector]:eq(0)").on("change", function() {
        _this._updateOptionsInSelector(1);

        if( product.options.length > 2 ) {
          _this._updateOptionsInSelector(2)
        };

        return true;
      });

      // When there is an update in the second dropdown.
      $("[data-single-option-selector]:eq(1)").on("change", function() {
        if( product.options.length > 2 ) {
          _this._updateOptionsInSelector(2);
        };
      });
    },

    _updateOptionsInSelector: function(selectorIndex) {
      var optionsMap = this._getNewOptionsMap();

      var key = "root";
      var selector = $("[data-single-option-selector]:eq(0)");

      if( selectorIndex == 1 ) {
        key = $("[data-single-option-selector]:eq(0)").val();
        selector = $("[data-single-option-selector]:eq(1)");
      } else if( selectorIndex == 2 ) {
        key = $("[data-single-option-selector]:eq(0)").val();
        key += " / " + $("[data-single-option-selector]:eq(1)").val();
        selector = $("[data-single-option-selector]:eq(2)");
      }

      var initialValue = selector.val();
      var allOptions = optionsMap[key] ? optionsMap[key].all : null;
      var availableOptions = optionsMap[key] ? optionsMap[key].available : null;

      var swatches = selector.parents(".selector-wrapper").find(".webyzeSwatches");

      if( allOptions ) {
        selector.empty();

        allOptions.forEach(function(option) {
          var newOption = $("<option></option>").val(option).html(option);
          selector.append(newOption);
        });

        selector.find("option").each(function() {
          var html = $(this).html().split(" - Sold out")[0];
          $(this).html(html);
        });

        setTimeout(function() {
          swatches.find(".swatchColor").removeClass("is-disabled");
        }, 200);

        var unavailableOptionElements = $(selector).find("option")
          .filter(function() {
            return !availableOptions.includes( $(this).val() );
          });

        setTimeout(function() {
          var unavailableSwatchElements = swatches.find(".swatchColor")
            .filter(function() {
              return !availableOptions.includes( $(this).find(".innerText").text().trim() );
            });

          unavailableSwatchElements.addClass("is-disabled");
        }, 200);

        unavailableOptionElements.each(function() {
          var isUnavailable = $(this).text().indexOf(" - Sold out") > -1;

          if( !isUnavailable ) {
            $(this).append(" - Sold out");
          }
        });

        if( availableOptions.includes(initialValue) ) {
          selector.val(initialValue);
        } else {
          selector.val( availableOptions[0] );
        }
      } else {
        selector.find("option").each(function() {
          var isUnavailable = $(this).text().indexOf(" - Sold out") > -1;

          if( !isUnavailable ) {
            $(this).append(" - Sold out");
          }
        });

        setTimeout(function() {
          swatches.find(".swatchColor").addClass("is-disabled");
        }, 200);
      }

      selector.trigger("change");
    },

    _getOptionsMap: function() {
      var product = this.product;

      var optionsMap = {};

      product.variants.forEach(function(variant) {
        if( !variant.available ) {
          return;
        }

        // Gathering values for the 1st drop-down.
        optionsMap["root"] = optionsMap["root"] || [];
        optionsMap["root"].push(variant.option1);
        optionsMap["root"] = uniq(optionsMap["root"]);

        // Gathering values for the 2nd drop-down.
        if( product.options.length > 1 ) {
          var key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);
          optionsMap[key] = uniq(optionsMap[key]);
        }

        // Gathering values for the 3rd drop-down.
        if( product.options.length > 2 ) {
          var key = variant.option1 + " / " + variant.option2;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option3);
          optionsMap[key] = uniq(optionsMap[key]);
        }
      });

      return optionsMap;
    },

    _getNewOptionsMap: function() {
      var product = this.product;

      var optionsMap = {};

      product.variants.forEach(function(variant) {
        // Gathering values for the 1st drop-down.
        optionsMap["root"] = optionsMap["root"] || {};
        optionsMap["root"].all = optionsMap["root"].all || [];
        optionsMap["root"].available = optionsMap["root"].available || [];
        optionsMap["root"].unavailable = optionsMap["root"].unavailable || [];

        optionsMap["root"].all.push(variant.option1);

        if( variant.available ) {
          optionsMap["root"].available.push(variant.option1);
        } else {
          optionsMap["root"].unavailable.push(variant.option1);
        }

        optionsMap["root"].all = uniq(optionsMap["root"].all);
        optionsMap["root"].available = uniq(optionsMap["root"].available);
        optionsMap["root"].unavailable = uniq(optionsMap["root"].unavailable);

        // Gathering values for the 2nd drop-down.
        if( product.options.length > 1 ) {
          var key = variant.option1;

          optionsMap[key] = optionsMap[key] || {};
          optionsMap[key].all = optionsMap[key].all || [];
          optionsMap[key].available = optionsMap[key].available || [];
          optionsMap[key].unavailable = optionsMap[key].unavailable || [];

          optionsMap[key].all.push(variant.option2);

          if( variant.available ) {
            optionsMap[key].available.push(variant.option2);
          } else {
            optionsMap[key].unavailable.push(variant.option2);
          }

          optionsMap[key].all = uniq(optionsMap[key].all);
          optionsMap[key].available = uniq(optionsMap[key].available);
          optionsMap[key].unavailable = uniq(optionsMap[key].unavailable);
        }

        // Gathering values for the 3rd drop-down.
        if( product.options.length > 2 ) {
          var key = variant.option1 + " / " + variant.option2;

          optionsMap[key] = optionsMap[key] || {};
          optionsMap[key].all = optionsMap[key].all || [];
          optionsMap[key].available = optionsMap[key].available || [];
          optionsMap[key].unavailable = optionsMap[key].unavailable || [];

          optionsMap[key].all.push(variant.option3);

          if( variant.available ) {
            optionsMap[key].available.push(variant.option3);
          } else {
            optionsMap[key].unavailable.push(variant.option3);
          }

          optionsMap[key].all = uniq(optionsMap[key].all);
          optionsMap[key].available = uniq(optionsMap[key].available);
          optionsMap[key].unavailable = uniq(optionsMap[key].unavailable);
        }
      });

      return optionsMap;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateProductPrices.bind(this));
    //this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    console.log(this.$featuredImage.length);
    if (this.$featuredImage.length > 0) {
      
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    (function swatch_load() {
      if ( $(".webyzeSwatches").length ) {
        $(document).trigger("swatchload");
      } else {
        setTimeout(function () {
          swatch_load();
        }, 10);
      }
    })();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      console.log('updateAddToCartState');
      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      console.log('updateProductPrices');
      console.log(evt);
      var variant = evt.variant;
      //console.log(variant);
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');

        // show sale labels
        $('.sale-label').removeClass("hide").addClass("show");

      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');

        // hide sale labels
        $('.sale-label').removeClass("show").addClass("hide");
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      console.log('updateProductImage');
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      //this.$featuredImage.attr('src', sizedImgUrl);
      
      //var featuredImageDataID = this.$featuredImage.closest('a').data('id');
      var featuredImageDataIDOld = this.$featuredImage.closest('a').data('id');
      console.log('featuredImageDataIDOld '+featuredImageDataIDOld);
      $('img[data-id="'+featuredImageDataIDOld+'"]').closest('a').removeAttr('data-product-featured-pop');
      $('img[data-id="'+featuredImageDataIDOld+'"]').removeAttr('data-product-featured-image');
      var featuredImageDataID = variant.featured_image.id;
      console.log('featuredImageDataID '+featuredImageDataID);
      this.$featuredImage.closest('a').data('id', variant.featured_image.id);
      $('img[data-id="'+featuredImageDataID+'"]').closest('a').attr('data-product-featured-pop', '');
      $('img[data-id="'+featuredImageDataID+'"]').attr('data-product-featured-image', '');
      //var featuredImageDataIDNew = $('img[data-product-featured-image]').closest('a').data('id');
      $( '.fancybox-gallery-group .fancybox-gallery-image' ).each(function( index, el ) {
        
        console.log('featuredImageDataIDNew ' + featuredImageDataID);
        if(el.getAttribute('data-id') == featuredImageDataID ){
          el.style.display = 'block';
          //$( this ).css('display', 'block');
          console.log( index + ": " + el.getAttribute('data-id') + ' : block');
        } else{
          //$( this ).css('display', 'none');
          el.style.display = 'none';
          console.log( index + ": " + el.getAttribute('data-id') + ' : none');
        }
      });
      //console.log($('.fancybox-gallery-group .fancybox-gallery-image').data('id'));

      /*$( '.fancybox-gallery-group .fancybox-gallery-image' ).each(function( index, el ) {
        console.log( index + ": " + $( this ).data('id') );
        if($( this ).data('id') === featuredImageDataID ){
          $( this ).removeAttr('data-fancybox');
        } else{
          $( this ).attr('data-fancybox', 'images-preview');
        }
      }); */

      // Add zoom switch
      var new_image = variant.featured_image.src;
      var new_image_zoom = slate.Image.getSizedImageUrl(variant.featured_image.src, '1600x1600' );

      if($(window).width() > 600) { // Show zoom only on larger screens
        //$('img[data-product-featured-image]')
       $('img[data-id="'+featuredImageDataID+'"]')
        .prop('src', new_image)
        .attr('data-zoom', new_image_zoom)
        .trigger('zoom.destroy')
        .css('display', 'block')
        .parent()
        .zoom({
          url: new_image_zoom,
          callback: function() {
            $(this).attr("data-pin-nopin", true);
          }
        });
        //console.log('larger than 600px');
      } else {
        //console.log('smaller than 600px');
      };

      // Change popup URL
      //$('a[data-product-featured-pop]')
      $('img[data-id="'+featuredImageDataID+'"]').closest('a').attr('href', new_image_zoom);

      // Show the standard image, hide the video
      $('.product-not-video').removeClass("hide").addClass("show");
      $('.product-video').removeClass("show").addClass("hide");
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();



if ($('body').hasClass('template-product')) {
  CartJS.init(cartjson);
}

$('[data-add-to-cart]').click(function(e) {
  e.preventDefault();
  // Check inventory quantity first.
//   var max = $('#Quantity').attr('max') || 0;
//   var qty = parseInt($('#Quantity').val());
//   if(qty > max){
//     $('#message').addClass('message-error').text('You can only add ' + max + ' to the cart. Please adjust quantity before continuing.').show();
//   } else {

    // Call the addItem() method.

    // Check to see if gift wrap is checked. If it is, add the line item property
    // + add gift wrapping to the cart. Otherwise just add the item to the cart.
    if ($('input[name="properties[giftwrap]"]').prop('checked')){
      CartJS.addItem($('[data-product-select]').val(), $('#Quantity').val(), {
      "giftwrap": "Add gift wrap"
      }, {

      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        // hide old errors
        $('#cart-error-message').removeClass("show").addClass("hide");

        $('.cart-count span').fadeOut();

        if ($('input[name="properties[giftwrap]"]').prop('checked')) {
          CartJS.addItem($('#giftwrap').attr('data-id'), $('#Quantity').val());
        }
        $('[data-add-to-cart-text]').html('Added to cart');
        $('#cart-add-message').removeClass("hide").addClass("show");
        $('.add-cart .btn').removeClass("unclicked").addClass('clicked');

        setTimeout(function () {
          $('#cart-add-message').removeClass("show").addClass("hide");
          //console.log('hide msg');
          $('[data-add-to-cart-text]').html('Add to cart');
          $('.add-cart .btn').removeClass("clicked").addClass('unclicked');
        }, 10000);

        var newQty = parseInt($('.cart-val').text()) + (parseInt($('#Quantity').val()) * 2);
        $('.cart-count span').html(newQty).fadeIn();
        $('.cart-count').show();
      },

      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        $('#cart-error-message').removeClass("hide").addClass("show");
        $('#cart-error-message').addClass('message-error');
        $('#cart-error-message').html('You have added more items than we have in stock.');
      }
    });
    } else {
      CartJS.addItem($('[data-product-select]').val(), $('#Quantity').val(), {}, {

      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {

        // hide old errors
        $('#cart-error-message').removeClass("show").addClass("hide");

        $('.cart-count span').fadeOut();

        $('[data-add-to-cart-text]').html('Added to cart');
        $('#cart-add-message').removeClass("hide").addClass("show");
        $('.add-cart .btn').removeClass("unclicked").addClass('clicked');

        setTimeout(function () {
          $('#cart-add-message').removeClass("show").addClass("hide");
          //console.log('hide msg 10');
          $('[data-add-to-cart-text]').html('Add to cart');
          $('.add-cart .btn').removeClass("clicked").addClass('unclicked');
        }, 10000);

        var newQty = parseInt($('.cart-val').text()) + parseInt($('#Quantity').val());
        $('.cart-count span').html(newQty).fadeIn();
        $('.cart-count').show();
      },

      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
          $('#cart-error-message').removeClass("hide").addClass("show");
          $('#cart-error-message').addClass('message-error');
          $('#cart-error-message').html('You have added more items than we have in stock.');
      }
    });
    }
//   }
});

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Mobile menu
  $('.trigger-secondary').click(function(){
    $(this).next().fadeIn();
    $(this).closest('.nav-menu').addClass('secondary-open');
  });
  $('.close-secondary').click(function(){
    $(this).closest('.secondary-links').fadeOut();
    $(this).closest('.nav-menu').removeClass('secondary-open');
  });
  $('.mobile-menu-trigger').click(function(){
    $('.mobile-menu').addClass('open');
    $('body').css('overflow','hidden');
    $('html').css('overflow','hidden');
  });
  $('.mobile-menu .close-menu').click(function(){
    $('.mobile-menu').removeClass('open');
    $('body').css('overflow','');
    $('html').css('overflow','');
  })
  $('.trigger-tertiary').click(function(){
    $(this).toggleClass('tertiary-open');
    $(this).next().toggleClass('tertiary-links-active');
  });

  // Add DoubleTapToGo to fix parent links on tap on touchscreens
  $( '.site-nav--has-submenu' ).doubleTapToGo();


  // Zoom
  $('.image-zoom')
  .wrap('<span style="display:inline-block"></span>')
  .css('display', 'block')
  .parent()
  .zoom({
    url: $(this).attr('data-zoom'),
    callback: function() {
      $(this).attr("data-pin-nopin", true);
    }
  });
});

// Zoom
if($('body').hasClass('template-product')) {
  // Non-video thumbnails
  $('a[data-product-single-thumbnail]').click(function(e){
    e.preventDefault();
    var featuredImageDataIDOld = $('img[data-product-featured-image]').closest('a').data('id');
    console.log('featuredImageDataIDOld' + featuredImageDataIDOld);
    $('img[data-id="'+featuredImageDataIDOld+'"]').closest('a').removeAttr('data-product-featured-pop');
    $('img[data-id="'+featuredImageDataIDOld+'"]').removeAttr('data-product-featured-image');
    var new_image = $(this).attr('href');
    console.log('a[data-product-single-thumbnail] clicked');
    var new_image_zoom = $(this).find('img').attr('data-zoom');
    console.log('new_image_zoom '+new_image_zoom);
    var dataImageID = $(this).data('id');
    console.log(dataImageID);
    //$('img[data-product-featured-image]').closest('a').data('id', dataImageID);
    $('img[data-id="'+dataImageID+'"]').closest('a').attr('data-product-featured-pop', '');
    $('img[data-id="'+dataImageID+'"]').attr('data-product-featured-image', '');
    //var featuredImageDataIDNew = $('img[data-product-featured-image]').closest('a').data('id');
    $( '.fancybox-gallery-group .fancybox-gallery-image' ).each(function( index, el ) {
      console.log( index + ": " + $( this ).data('id') );
      console.log(dataImageID);
      if($( this ).data('id') == dataImageID ){
        $( this ).css('display', 'block');
      } else{
        $( this ).css('display', 'none');
      }
    }); 
    /*$( '.fancybox-gallery-group .fancybox-gallery-image' ).each(function( index, el ) {
      console.log( index + ": " + $( this ).data('id') );
      console.log(featuredImageDataID);
      if($( this ).data('id') == featuredImageDataID ){
        $( this ).removeAttr('data-fancybox');
      } else{
        $( this ).attr('data-fancybox', 'images-preview');
      }
    }); */
    
    //$('img[data-product-featured-image]')
    $('img[data-id="'+dataImageID+'"]')
    .prop('src', new_image)
    .attr('data-zoom', new_image_zoom)
    .trigger('zoom.destroy')
    .css('display', 'block')
    .parent()
    .zoom({
      url: new_image_zoom,   //$(this).attr('data-zoom'),
      callback: function() {
        $(this).attr("data-pin-nopin", true);
      }
    });
    /*$('img[data-id="'+dataImageID+'"]')
    .prop('src', new_image)
    .attr('data-zoom', new_image_zoom)
    .trigger('zoom.destroy')
    .unwrap()
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      url: new_image_zoom,   //$(this).attr('data-zoom'),
      callback: function() {
        $(this).attr("data-pin-nopin", true);
      }
    }); */

    // Change popup URL
    //$('a[data-product-featured-pop]')
    $('img[data-id="'+dataImageID+'"]').closest('a').attr('href', new_image_zoom);

    // Show the standard image, hide the video
    $('.product-not-video').removeClass("hide").addClass("show");
    $('.product-video').removeClass("show").addClass("hide");
  });

  // Video thumbnails
  $('a[data-product-single-thumbnail-video]').click(function(e){
    e.preventDefault();

    // Hide the standard image, show the video
    $('.product-not-video').addClass("hide");
    $('.product-video').removeClass("hide").addClass("show");

    // Update alt to use with videos
    var new_alt = $(this).find('img').attr('alt');
    //console.log(new_alt);

    // Use the alt code as the video embed
    $('.product-video').html(new_alt);
  });
}

if($('body').hasClass('template-product')){
  $(document).ready(function(){
    var removeZoom = function() {
      if($(window).width() < 600) {
        $('img[data-product-featured-image]').trigger('zoom.destroy'); // destroy first img zoom
        //console.log('first img zoom destroyed');

        $('a[data-product-single-thumbnail]').click(function(e){ // destroy thumb click zoom
          $('img[data-product-featured-image]').trigger('zoom.destroy')
        });
        //console.log('thumb click zoom destroyed');
      }
    };

    // Fire on DOM ready
    removeZoom();
  });
}

if($('body').hasClass('template-collection')) {
  $(document).ready(function() {
    $('.collection-sidebar .toggled-content').hide();

    $('.collection-sidebar .toggle').each(function(index, value){
      // Add tabindex=0 to make toggle keyboard accessible
      $(this).attr('tabindex', '0');
    });

    $('.toggle-collection-menus').find('.toggle').click(function(){
      // Set this toggle to active
      $(this).toggleClass('active');

      $(this).find('[data-fa-i2svg]')
        .toggleClass('fa-chevron-down')
        .toggleClass('fa-chevron-up');

      // Remove active class on inactive toggles
      $(".toggle").not($(this)).removeClass( 'active' );
      // Expand or collapse this panel
      $(this).next().slideToggle('fast');
    });

    // Make toggles keyboard accessible
    $('.toggle-collection-menus').find('.toggle').keydown(function(e){
      if(e.which == 40){ // down arrow key
          e.preventDefault();
          $(this).click();
      }
    });
  });
}

if($('body').hasClass('template-product')){
  $(window).load(function () {
    $('label.top-label').removeClass('hide').addClass('show');
    // Webyze move label
    $('.webyzeSwatches').each(function() {
      $(this).siblings('label.top-label').eq(0).addClass('hide');
      $(this).siblings('label.bottom-label').eq(0).removeClass('hide').addClass('show');
    });

    // Hide Webyze Swatches hover tooltips
    $('.webyzeTooltip').addClass('hide');

    // Add current swatch label to bottom label on load
    var firstCurrentSwatchName  = $('.swatchColor.currentSwatch').attr('data-name');
    $('label.bottom-label').append('<span class="new-swatch-label">: ' + firstCurrentSwatchName + '</span>');
    //console.log(' : first' + firstCurrentSwatchName);

    // Add current swatch label to bottom label on click
    $('.swatchColor').click(function(){
      var currentSwatchName  = $('.swatchColor.currentSwatch').attr('data-name');
      //console.log(' :' + currentSwatchName);
      $('.new-swatch-label').remove();
      $('label.bottom-label').append('<span class="new-swatch-label">: ' + currentSwatchName + '</span>');
    });
  });
}

if($('body').hasClass('template-collection')){
  $(document).ready(function(){
    ajaxify();

    var movesorting = function() {
      if($(window).width() < 879) {
        $('.toggle-collection-menus .collection-sorting').appendTo('.collection-sorting-pagination');
        //$('.collection-sorting-pagination .collection-sorting').insertBefore('.filter-collection-menus');
        //$('.collection-sorting-pagination .collection-sorting').appendTo('.toggle-collection-menus');
      } else {
        $('.toggle-collection-menus .collection-sorting').appendTo('.collection-sorting-pagination');
      }
    };

    // Fire on DOM ready
    movesorting();

    // Fire upon resize
    $(window).resize(movesorting);
  });
}

if($('body').hasClass('template-product')){
  $(document).ready(function() {
    // Sliders
      var product_thumbs = $(".product-thumbs");
      product_thumbs.slick({
      arrows: true,
      autoplay: false,
      infinite: true,
      vertical: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class=\"fal fa-chevron-up\"></i></button>',
      nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class=\"fal fa-chevron-down\"></i></button>'
    });

    // Calculate the heighest slide and set a top/bottom margin for other children.
    // As variableHeight is not supported yet: https://github.com/kenwheeler/slick/issues/1803
    var maxSlickHeight = -1;
    $('.slick-slide').each(function() {
      if ($(this).height() > maxSlickHeight) {
        maxSlickHeight = $(this).height();
      }
    });
    $('.slick-slide').each(function() {
      if ($(this).height() < maxSlickHeight) {
        $(this).css('margin', Math.ceil((maxSlickHeight-$(this).height())/2) + 'px 0');
      }
    });
  });
}